module.exports = __webpack_public_path__ + "media/large/destin-florida-communities-d9613652.jpg";